import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicePlus, TYPE } from '../models/ServicePlus';
import { UtilService } from './util.service'; import { CtrlBaseComponent } from '../controls/ctrl-base.component';
import { OperationException } from '../models/OperationException';
import { HttpService } from './http.service';
import { Action, ActionType } from '../models';

@Injectable()
export class ActionService {

  tokenService: any;

  constructor(private httpService: HttpService, private utilService: UtilService) { }

  ExecuteServiceOperation(entity: string, operationName: string, event: any, response: any, component: CtrlBaseComponent, uri: string): Observable<any> {
    const url = `${HttpService.ENDPOINT}/api/process/${entity}/${operationName}`;
    const serv = this.utilService.BuildServicePlus(entity, operationName, TYPE.SERVICE, event, response, component.getViewId());
    let elements = this.getEventPostActionComponents(event);
    return this.ExecuteService(url, serv, elements, event);
  }

  ExecuteCrudOperation(entity: string, operationName: string, event: any, response: any, component: CtrlBaseComponent, uri: string): Observable<any> {
    const url = `${HttpService.ENDPOINT}/api/process/${entity}/${operationName}`;
    const serv = this.utilService.BuildServicePlus(entity, operationName, TYPE.ENTITY, event, response, component.getViewId());
    let elements = this.getEventPostActionComponents(event);
    return this.ExecuteService(url, serv, elements, event);
  }

  ExecuteGenericOperation(event: Action, response: any, component: CtrlBaseComponent): Observable<any> {
    event.type = ActionType.ACTION;
    const serv = this.utilService.BuildServicePlus(event.Entity, event.Operation, ActionType.ACTION, event, response, component.getViewId());
    let elements = this.getEventPostActionComponents(event);
    return this.ExecuteService(`${HttpService.ENDPOINT}/${event.Endpoint}`, serv, elements, event);
  }

  getEventPostActionComponents(event: any): string {
    let elements = '';
    if (event) {
      if (event.postAction && (event.postAction.action == 'utl_set' || event.postAction.action == 'utl_loadSelectOptions')) {
        let arrayActions = event.postAction.actionParams;
        for (let i in arrayActions) {
          elements += elements == '' ? arrayActions[i] : '.' + arrayActions[i];
        }
      }
    }
    return elements;
  }

  private ExecuteService(url: string, service: ServicePlus, elements: string, event: any): Observable<any> {
    try {
      this.utilService.checkDefaultParams(service);
      if (this.utilService.validateServicePlus(service)) {
        return this.httpService.post(url, service, elements);
      } else {
        throw new OperationException(`No se pudo ejecutar la operación de \"${event.displayName ? event.displayName : service.OperationName}\" por favor verifique los campos requeridos`);
      }
    }
    catch (vException) {
      throw new OperationException(`No se pudo ejecutar la operación de \"${event.displayName ? event.displayName : service.OperationName}\" por favor verifique los campos requeridos`);

    }
  }

}


